import { Component, inject, isDevMode } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'bodyanalytics-server-error',
  imports: [CommonModule],
  templateUrl: './server-error.component.html',
  styleUrl: './server-error.component.scss',
})
export class ServerErrorComponent {
  readonly auth = inject(AuthService);
  readonly isDev = isDevMode();
}
